import React from 'react';
// @ts-ignore - Prisma client types
import type {  User  } from '@prisma/client';
import { useMentions } from '@/hooks/useMentions';
import MentionDropdown from './MentionDropdown';

interface MentionTextAreaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  rows?: number;
  maxLength?: number;
}

export default function MentionTextArea({
  value,
  onChange,
  placeholder = 'Write something...',
  className = '',
  rows = 3,
  maxLength,
}: MentionTextAreaProps) {
  const {
    mentionState,
    textareaRef,
    handleInput,
    insertMention,
    closeMentions,
  } = useMentions();

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e?.target?.value);
    handleInput(e);
  };

  const handleSelectMention = (user: User) => {
    if (textareaRef.current) {
      const beforeText = value.slice(0, mentionState.mentionStart);
      const afterText = value.slice(textareaRef?.current?.selectionStart);
      const mention = `@${user.username} `;
      const newText = beforeText + mention + afterText;
      onChange(newText);
      insertMention(user);
    }
  };

  return (
    <div className="relative">
      <textarea
        ref={textareaRef}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={`w-full px-4 py-2 text-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:border-blue-500 ${className}`}
        rows={rows}
        maxLength={maxLength}
      />
      {mentionState.isActive && (
        <MentionDropdown
          searchText={mentionState.searchText}
          onSelect={handleSelectMention}
          onClose={closeMentions}
          position={mentionState.position}
        />
      )}
    </div>
  );
}